var _path, _path2, _path3, _circle, _circle2, _path4, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndiaflag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 36",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#138808",
    d: "M0 27a4 4 0 0 0 4 4h28a4 4 0 0 0 4-4v-5H0v5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F93",
    d: "M36 14V9a4 4 0 0 0-4-4H4a4 4 0 0 0-4 4v5h36z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#F7F7F7",
    d: "M0 13.667h36v8.667H0z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "navy",
    cx: 18,
    cy: 18,
    r: 4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    fill: "#F7F7F7",
    cx: 18,
    cy: 18,
    r: 3.375
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m18.1 16.75-.1.65-.1-.65.1-1.95zm-.928-1.841.408 1.909.265.602-.072-.653zm-.772.32.888 1.738.412.513-.238-.613zm-.663.508 1.308 1.45.531.389-.389-.531zm-.508.663 1.638 1.062.613.238-.513-.412zm-.32.772 1.858.601.653.072-.602-.265zM14.8 18l1.95.1.65-.1-.65-.1zm.109.828 1.909-.408.602-.265-.653.072zm.32.772 1.738-.888.513-.412-.613.238zm.508.663 1.45-1.308.389-.531-.531.389zm.663.508 1.062-1.638.238-.613-.412.513zm.772.32.601-1.858.072-.653-.265.602zM18 21.2l.1-1.95-.1-.65-.1.65zm.828-.109-.408-1.909-.265-.602.072.653zm.772-.32-.888-1.738-.412-.513.238.613zm.663-.508-1.308-1.45-.531-.389.389.531zm.508-.663-1.638-1.062-.613-.238.513.412zm.32-.772-1.858-.601-.653-.072.602.265zM21.2 18l-1.95-.1-.65.1.65.1zm-.109-.828-1.909.408-.602.265.653-.072zm-.32-.772-1.738.888-.513.412.613-.238zm-.508-.663-1.45 1.308-.389.531.531-.389zm-.663-.508-1.062 1.638-.238.613.412-.513zm-.772-.32-.601 1.858-.072.653.265-.602z",
    fill: "#6666B3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "navy"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 17.56,
    cy: 14.659,
    r: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.71,
    cy: 14.887,
    r: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.948,
    cy: 15.326,
    r: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.326,
    cy: 15.948,
    r: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.887,
    cy: 16.71,
    r: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.659,
    cy: 17.56,
    r: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.659,
    cy: 18.44,
    r: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.887,
    cy: 19.29,
    r: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.326,
    cy: 20.052,
    r: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.948,
    cy: 20.674,
    r: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.71,
    cy: 21.113,
    r: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.56,
    cy: 21.341,
    r: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.44,
    cy: 21.341,
    r: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.29,
    cy: 21.113,
    r: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.052,
    cy: 20.674,
    r: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.674,
    cy: 20.052,
    r: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.113,
    cy: 19.29,
    r: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.341,
    cy: 18.44,
    r: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.341,
    cy: 17.56,
    r: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.113,
    cy: 16.71,
    r: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.674,
    cy: 15.948,
    r: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.052,
    cy: 15.326,
    r: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.29,
    cy: 14.887,
    r: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.44,
    cy: 14.659,
    r: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 0.9
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndiaflag);
export default __webpack_public_path__ + "static/media/indiaflag.c4c4b3b5f3f8bcefb487a920e5525b77.svg";
export { ForwardRef as ReactComponent };